<template>
    <div class="news-container">
        <div class="top-container">
            <span class="title">艺术资讯</span>

            <span class="desc">/Art Consultation</span>

        </div>
        <div class="news-box" v-if="newsList.length">
            <ul class="title-box">
                <li class="title-item" :class="{ active: index === selected }" @click="handleClick(index)"
                    v-for="(item, index) in newsList" :key="index">
                    <div class="date-box">
                        <div class="date-day">{{ item.createTime.split(' ')[0].split('-')[2] }}</div>
                        <div class="time">{{ item.createTime.split('-').slice(0,2).join('/') }}</div>
                    </div>
                    <div class="space"></div>
                    <div class="title-box">
                        <span>{{ item.name }}</span>
                    </div>
                </li>
            </ul>
            <div class="img-box">
                <img v-for="(item, index) in newsList" v-show="index === selected"
                    class="animate__animated animate__fadeIn" :src="item.imageUrl" :key="index" alt="" srcset="">
            </div>
        </div>
    </div>
</template>

<script>
import { getNews } from '@/api/getNews'
export default {
    data () {
        return {
            newsList: [],
            selected: 0 // 新闻选择
        }
    },
    async created () {
        // 加载远程数据
        this.newsList = await getNews()
        // console.log(this.newsList)
    },
    methods: {
        handleClick (index) {
            this.selected = index
        }
    }

}
</script>

<style lang="less" scoped>
.news-container {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    overflow: hidden;

    .top-container {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 50px;
        padding-top: 100px;
        box-sizing: border-box;
        .title {
            display: block;
            width: auto;
            text-align: start;
            font-weight: 800;
            font-size: 32px;
            color: #FF793A;
            margin-right: 10px;
        }
        .desc{
            display: block;
            width: 1500px;
            text-align: start;
            font-size: 24px;
            color: #ACACAE;

        }
    }

    .news-box {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;

        width: 100%;
        height: auto;
        padding-bottom: 20px;
        box-sizing: border-box;

        .title-box {
            display: flex;
            flex-wrap: wrap;
            width: 500px;
            height: 700px;
            // background: -webkit-linear-gradient(rgb(254, 205, 176), #F6B38C);
            box-sizing: border-box;
            border-radius: 10px 0 0 10px;

            li {
                display: flex;
                align-items: center;
                width: 100%;
                height: 70px;
                cursor: pointer;
                color: #040301;
                padding-bottom: 5px;
                box-sizing: border-box;
                padding: 10px;

                .date-box {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    width: 40px;
                    height: 70px;
                    box-sizing: border-box;

                    .date-day {
                        width: 100%;
                        height: 40px;
                        font-size: 20px;
                        font-weight: 600;
                        padding-top: 15px;
                        box-sizing: border-box;

                    }

                    .time {
                        width: 100%;
                        height: 30px;
                        font-size: 12px;
                    }
                }

                .space {
                    width: 1px;
                    height: 30px;
                    margin: 0 10px;
                    background-color: #040301;
                }

                .title-box {
                    border-radius: 0;
                    padding: 0;
                    display: block;
                    height: 70px;
                    background-image: none;
                    padding-top: 15px;
                    box-sizing: border-box;

                    span {
                        text-align: start;
                        font-size: 14px;
                        line-height: 1.5;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                    }
                }

                &:hover {
                    color: #1F2329;
                    font-weight: 500;
                    transition: all.3s;

                    .space {
                        background-color: #1F2329;
                    }
                }

                &.active {
                    color: #fff;
                    background-image: url(~@/assets/img/news-active.png);
                    background-size: 100% 100%;

                    transition: all.3s;

                    .space {
                        background-color: #fff;
                    }
                }
            }
        }

        .img-box {
            width: 1100px;
            height: 700px;
            overflow: hidden;
            padding-left: 50px;
            border-radius: 0 10px 10px 0px;

            img {
                width: 100%;
                height: 100%;
                object-fit: fill;
            }
        }
    }
}
</style>